module.exports = __webpack_public_path__ + "img/pic-bg2@2x.40091a68.png";